import React from 'react';
import { mergeCatalogs, translateMessage } from './formatText';

const I18nContext = React.createContext({
  locale: 'en',
  messages: {},
});

export function I18nProvider({ catalogs = [], children, locale = 'en' }) {
  const messages = React.useMemo(() => mergeCatalogs(catalogs), [catalogs]);
  const value = React.useMemo(() => ({ locale, messages }), [locale, messages]);

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export function useText() {
  const { messages } = React.useContext(I18nContext);

  return React.useCallback((key, values, fallback) => (
    translateMessage(messages, key, values, fallback)
  ), [messages]);
}

export function useLocale() {
  return React.useContext(I18nContext).locale;
}
